import { render, staticRenderFns } from "./OrticMultiSelect.vue?vue&type=template&id=1fc484a5&"
import script from "./OrticMultiSelect.vue?vue&type=script&lang=js&"
export * from "./OrticMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./OrticMultiSelect.vue?vue&type=style&index=0&id=1fc484a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports